import { isFoundingOfferLive } from "@musicfy/contants/FoundingOffer";
import { api } from "@musicfy/utils";

/**
 * Seat availability for Founding UI. Fail-open while loading or on error so a
 * Paddle blip does not hide the offer; hide only when the server reports
 * exhausted seats.
 */
export const useFoundingOfferAvailability = (): {
  seatsAvailable: boolean | null;
  isLoading: boolean;
} => {
  const live = isFoundingOfferLive();
  const { data, isError, isLoading } =
    api.subscription.getFoundingOfferAvailability.useQuery(undefined, {
      enabled: live,
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    });

  if (!live) {
    return { seatsAvailable: false, isLoading: false };
  }

  if (isLoading || isError || data == null) {
    return { seatsAvailable: null, isLoading };
  }

  return { seatsAvailable: data.available, isLoading: false };
};
